<header>
  <div class="content-wrap">
    <h2>Games</h2>
  </div>
</header>
<section class="game-card">
  <div class="flex-item">
    <ul class="game-details" *ngFor="let game of games.results">
      <li *ngIf="game.background_image">
        <img src="{{ game.background_image }}" alt="game" />
      </li>
      <li *ngIf="game.id">
        <p class="game-id">id: {{ game.id }}</p>
      </li>
      <li *ngIf="game.name">Name: {{ game.name }}</li>
      <li *ngIf="game.platform">Platform: {{ game.platform }}</li>
      <li *ngIf="game.released">Released: {{ game.released }}</li>
      <li *ngIf="game.rating">Rating:{{ game.rating }}</li>
      <li *ngIf="game.genres">
        Genres:
        <div class="genres" *ngFor="let genre of game.genres">
          <span *ngIf="genre.name">{{ genre.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</section>
<footer>
  <div class="content-wrap">
    <h2>Let's Keep in Touch!</h2>

    <!-- Social media and contact links. Add or remove any networks. -->
    <ul class="contact-list">
      <li>
        <a href="http://petercarey.co.uk" target="_blank">petercarey.co.uk</a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/peter-carey-a697aa37/"
          target="_blank"
          >LinkedIn</a
        >
      </li>
    </ul>
  </div>
</footer>
